export const NUMBER_OF_GAMES_TO_UNLOCK_RANKED = 5;
